// The climate widget can only render four HVAC modes: it has an icon and a
// label for off / heat / cool / heat_cool and nothing else. getModeLabel used
// to fall back to 'Off' for anything it didn't recognise, so a thermostat
// advertising the full HA set (dry, fan_only, auto...) produced a segment
// reading "Off Heat Cool Off Auto Off". Worse than ugly: those surplus buttons
// were live, so tapping one labelled "Off" actually committed dry or fan_only.
//
// Filtering at the source means the widget only ever offers modes it can name
// and represent honestly.
const SUPPORTED_HVAC_MODES = new Set(['off', 'heat', 'cool', 'heat_cool']);

// Shown when there is no HVAC to talk to, so the control keeps its familiar
// shape instead of collapsing to an empty strip. Rendered non-interactive by
// the caller — this is a placeholder, not an offer.
export const UNAVAILABLE_HVAC_MODES: readonly string[] = ['heat', 'cool', 'off'];

/**
 * Reduce a reported `hvac_modes` attribute to the modes this widget can render.
 * Reported order is preserved so the segment doesn't reshuffle under residents
 * who are used to their thermostat's layout; duplicates and unsupported values
 * are dropped.
 */
export function normalizeHvacModes(reported: unknown): string[] {
  if (!Array.isArray(reported)) return [];

  const out: string[] = [];
  for (const mode of reported) {
    if (typeof mode !== 'string') continue;
    if (!SUPPORTED_HVAC_MODES.has(mode)) continue;
    if (out.includes(mode)) continue;
    out.push(mode);
  }
  return out;
}
